export const ACCOUNT = 'https://clientaccountserver.lessonplan.cn'
export const PASSPORT_CLIENT = 'https://clientpassport.lessonplan.cn'
export const TEAMURL = 'https://templateserver.lessonplan.cn'
export const TSINGHUA_API = 'https://tsinghuashowserver.lessonplan.cn'
export const ORGURL = 'https://accountorg.lessonplan.cn'
export const CLASS_MESSAGE_API = "https://lessonplaydata.lessonplan.cn/unifydata"